/*
 * @FilePath: util.js
 * @Author: Aron
 * @Date: 2023-07-18 11:23:26
 * @LastEditors: hushun hushun@songshuai.com
 * @LastEditTime: 2025-06-09 16:34:13
 * Copyright: 2023 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion:
 */
/*
 * @FilePath: util.js
 * @Author: Aron
 * @Date: 2023-07-11 11:05:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-11 11:26:48
 * Copyright: 2023 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion:
 */
import * as coordtransform from "coordtransform";
import { getBaseUrl } from "./config";
import { getCookie } from "./cookie";
import LoginUserHelper from "./LoginUserHelper";
/**
 * 2019-05-14
 * Created by Jeremy.caoyu
 * CRM基础验证函数
 *
 */

export const isIP = (ip) => {
  let reg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
  if (
    reg.test(ip) &&
    RegExp.$1 < 256 &&
    RegExp.$2 < 256 &&
    RegExp.$3 < 256 &&
    RegExp.$4 < 256
  ) {
    return true;
  } else {
    return false;
  }
};

export function padding(v) {
  let value = v + "";
  if (value.length < 2) {
    value = "0" + value;
  }
  return value;
}
//时间转换 => YYYY-MM-dd
export function format(d) {
  return !!d && typeof d !== "string"
    ? d.getFullYear() +
        "-" +
        padding(d.getMonth() + 1) +
        "-" +
        padding(d.getDate())
    : d;
}

export function number2DateTime(value, fmt = "yyyy-MM-dd HH:mm:ss") {
  // yyyy-MM-dd HH:mm:ss
  if (isNaN(value)) return "";
  const date = new Date(Number(value));
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();
  return fmt
    .replace("yyyy", year.toString())
    .replace("yy", (year % 100).toString())
    .replace("MM", month > 9 ? month.toString() : "0" + month)
    .replace("dd", day > 9 ? day.toString() : "0" + day)
    .replace("HH", hour > 9 ? hour.toString() : "0" + hour)
    .replace("mm", minute > 9 ? minute.toString() : "0" + minute)
    .replace("ss", second > 9 ? second.toString() : "0" + second);
}
export function isPhone(str) {
  // 手机号验证
  // let reg = /^(13[0-9]|15[012356789]|17[013678]|18[0-9]|14[57])[0-9]{8}$/;
  let reg = /^1[3-9][0-9]{9}$/;
  if (reg.test(str)) {
    return true;
  } else {
    return false;
  }
}
export function isTel(str) {
  // 座机验证
  // let reg = /([0-9]{3,4}-)?[0-9]{7,8}/;
  let reg = /0\d{2}-\d{7,8}/;
  if (reg.test(str)) {
    return true;
  } else {
    return false;
  }
}
export function isNumber(value) {
  let patrn = /^[0-9]*$/;
  if (patrn.exec(value) === null || value === "") {
    return false;
  } else {
    return true;
  }
}
export function isQQ(str) {
  // QQ号验证
  let reg = /^[1-9][0-9]{4,15}$/;
  if (reg.test(str)) {
    return true;
  } else {
    return false;
  }
}
export function isEmail(str) {
  // 邮箱验证
  let reg =
    /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
  // let reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
  if (reg.test(str)) {
    return true;
  } else {
    return false;
  }
}
export function checkIDCard(str) {
  // 身份证验证
  const patternMainLand =
      /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/, //大陆
    patternHongkong =
      /([A-Za-z](\d{6})\d)|(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X|x)/, //香港、大陆
    patternTaiwan = /^[a-zA-Z][0-9]{9}$/, //台湾
    patternMacao = /^[1|5|7][0-9]{6}[0−9Aa]/; //澳门
  if (
    patternMainLand.test(str) ||
    patternHongkong.test(str) ||
    patternTaiwan.test(str) ||
    patternMacao.test(str)
  ) {
    return true;
  } else {
    return false;
  }
}

/**
 * 获取本周、本季度、本月、上月的开端日期、停止日期
 */
let now = new Date(); //当前日期
let nowDayOfWeek = now.getDay() || 7; //今天本周的第几天
let nowDay = now.getDate(); //当前日
let nowMonth = now.getMonth(); //当前月
let nowYear = now.getFullYear(); //当前年
nowYear += nowYear < 2000 ? 1900 : 0;

//获得某月的天数
export function getMonthDays(myMonth) {
  let monthStartDate = new Date(nowYear, myMonth, 1);
  let monthEndDate = new Date(nowYear, myMonth + 1, 1);
  let days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
  return days;
}

//获得本周的开端日期
export function getWeekStartDate() {
  let weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1);
  return format(weekStartDate);
}
//获得本周的停止日期
export function getWeekEndDate() {
  let weekEndDate = new Date(nowYear, nowMonth, nowDay + (7 - nowDayOfWeek));
  return format(weekEndDate);
}

// 获取指定日期所在周的开端日期
export function getAssignWeekStartDate(date) {
  const nowDate = new Date(date),
    nowYear = nowDate.getFullYear(), //当前年
    nowMonth = nowDate.getMonth(), //当前月
    nowDay = nowDate.getDate(), //当前日
    nowDayOfWeek = nowDate.getDay() || 7;
  let weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1);
  return format(weekStartDate);
}

// 获取指定日期所在周的停止日期
export function getAssignWeekEndDate(date) {
  const nowDate = new Date(date),
    nowYear = nowDate.getFullYear(), //当前年
    nowMonth = nowDate.getMonth(), //当前月
    nowDay = nowDate.getDate(), //当前日
    nowDayOfWeek = nowDate.getDay() || 7;
  let weekEndDate = new Date(nowYear, nowMonth, nowDay + (7 - nowDayOfWeek));
  return format(weekEndDate);
}
// 获取两个日期之间的毫秒数差值
export function getTimeDifference(date1, date2) {
  var diff = Math.abs(date2 - date1); 
  
  return diff;
}
//获得本月的开端日期
export function getMonthStartDate() {
  let monthStartDate = new Date(nowYear, nowMonth, 1);
  return format(monthStartDate);
}

//获得本月的停止日期
export function getMonthEndDate() {
  let monthEndDate = new Date(nowYear, nowMonth, getMonthDays(nowMonth));
  return format(monthEndDate);
}

//将"2018-05-19T08:04:52.000+0000"这种格式的时间转化为正常格式
export function timeFormat(time) {
  let d = new Date(time);

  let year = d.getFullYear(); //年
  let month = d.getMonth() + 1; //月
  let day = d.getDate(); //日

  let hh = d.getHours(); //时
  let mm = d.getMinutes(); //分
  let ss = d.getSeconds(); //秒

  let clock = year + "-";

  if (month < 10) clock += "0";

  clock += month + "-";

  if (day < 10) clock += "0";

  clock += day + " ";

  if (hh < 10) clock += "0";

  clock += hh + ":";
  if (mm < 10) clock += "0";
  clock += mm + ":";

  if (ss < 10) clock += "0";
  clock += ss;
  return clock;
}

export function GetQueryString(
  searchUrl = window.location.search || window.location.hash.split("?")[1],
  name
) {
  let search = searchUrl && searchUrl.replace(/\?/, "").split("&");
  let data = {};
  search &&
    search.forEach((item, index) => {
      let items = item.split("="),
        key = items[0],
        val = items[1];
      data[key] = decodeURI(val);
    });
  return name ? data[name] : data;
}

// 生日 计算年龄
export function jsGetAge(strBirthday) {
  let returnAge;
  let strBirthdayArr = strBirthday.split("-");
  let birthYear = strBirthdayArr[0];
  let birthMonth = strBirthdayArr[1];
  let birthDay = strBirthdayArr[2];

  let d = new Date();
  let nowYear = d.getFullYear();
  let nowMonth = d.getMonth() + 1;
  let nowDay = d.getDate();

  if (nowYear === birthYear) {
    returnAge = 0; //同年 则为0岁
  } else {
    let ageDiff = nowYear - birthYear; //年之差
    if (ageDiff > 0) {
      if (nowMonth === birthMonth) {
        let dayDiff = nowDay - birthDay; //日之差
        if (dayDiff < 0) {
          returnAge = ageDiff - 1;
        } else {
          returnAge = ageDiff;
        }
      } else {
        let monthDiff = nowMonth - birthMonth; //月之差
        if (monthDiff < 0) {
          returnAge = ageDiff - 1;
        } else {
          returnAge = ageDiff;
        }
      }
    } else {
      returnAge = -1; //返回-1 表示出生日期输入错误 晚于今天
    }
  }
  return returnAge < 0 ? 0 : returnAge; //返回周岁年龄
}

export const CallActionList = {
  signIn: "签入",
  signOut: "签出",
  setIdle: "置闲",
  setBusy: "置忙",
  setMonitor: "监控",
  setHangup: "挂断",
};
export const CallStatusList = [
  {
    name: "未签入",
    canAction: [{ key: "signIn", name: "签入" }],
  },
  {
    name: "空闲中",
    canAction: [
      { key: "签出", name: "signOut" },
      { key: "setBusy", name: "置忙" },
      { key: "setMonitor", name: "监控" },
    ],
  },
  {
    name: "忙碌中",
    canAction: [
      { key: "签出", name: "signOut" },
      { key: "setIdle", name: "置闲" },
      { key: "setMonitor", name: "监控" },
    ],
  },
  {
    name: "通话中",
    canAction: [
      { key: "签出", name: "signOut" },
      { key: "setIdle", name: "置闲" },
      { key: "setMonitor", name: "监控" },
    ],
  },
];

export const checkCallStatus = (CallCenterStatus) => {
  return new Promise((resolve) => {
    switch (CallCenterStatus) {
      case 1:
        message.warning("请先签入,再拨打电话");
        resolve(false);
        break;
      case 2:
        resolve(true);
        break;
      case 3:
        message.warning("请先置闲,再拨打电话");
        resolve(false);
        break;
      case 4:
        message.warning("座席忙，请结束当前通话后再拨");
        resolve(false);
        break;
      default:
        message.warning("请先签入,再拨打电话");
        resolve(false);
        break;
    }
  });
};

export const exportExl = (
  url,
  data = {},
  fileName = "",
  methods = "post",
  type = 1
) => {
  let xhr = new XMLHttpRequest();
  xhr.open(methods, getBaseUrl() + url, true);
  xhr.responseType = "blob";
  xhr.setRequestHeader("Authorization", LoginUserHelper.getUserToken()); // 请求头中的验证信息等（如果有）
  xhr.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
  xhr.onload = function () {
    if (this.status === 200) {
      let type = xhr.getResponseHeader("Content-Type");
      let blob = new Blob([this.response], { type: type });
      if (typeof window.navigator.msSaveBlob !== "undefined") {
        window.navigator.msSaveBlob(blob, fileName);
      } else {
        let URL = window.URL || window.webkitURL;
        let objectUrl = URL.createObjectURL(blob);
        if (fileName) {
          let a = document.createElement("a");
          if (typeof a.download === "undefined") {
            window.location = objectUrl;
          } else {
            a.href = objectUrl;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
          }
        } else {
          window.location = objectUrl;
        }
      }
    }
  };
  xhr.send(JSON.stringify(data));
};

// 清除除指定格式的localstorage
export function clearLocalStorage() {
  const StorageList = Object.keys(localStorage);
  StorageList.forEach((item) => {
    if (item.indexOf("Permanent_") !== 0) {
      localStorage.removeItem(item);
    }
  });
}


export function getMonthFrist(timestamp) {
  let date = timestamp ? new Date(timestamp) : new Date()
  let year = date.getFullYear()
  let month = date.getMonth()
  return new Date(year, month, 1) * 1
}

function getDate(time) {
  if (time) {
    let val = new Date(time);
    let Y = val.getFullYear();
    let M = (val.getMonth() + 1) < 10 ? '0' + (val.getMonth() + 1) : (val.getMonth() + 1);
    let D = val.getDate() < 10 ? '0' + val.getDate() : val.getDate();
    let h = val.getHours() < 10 ? '0' + val.getHours() : val.getHours();
    let m = val.getMinutes() < 10 ? '0' + val.getMinutes() : val.getMinutes();
    return Y + '-' + M + '-' + D;
  }
  return ''
}
export function getDateNew(time) {
  if (time) {
    let val = new Date(time);
    let Y = val.getFullYear();
    let M = (val.getMonth() + 1) < 10 ? '0' + (val.getMonth() + 1) : (val.getMonth() + 1);
    let D = val.getDate() < 10 ? '0' + val.getDate() : val.getDate();
    let h = val.getHours() < 10 ? '0' + val.getHours() : val.getHours();
    let m = val.getMinutes() < 10 ? '0' + val.getMinutes() : val.getMinutes();
    return Y + '-' + M + '-' + D;
  }
  return ''
}
//获取当月第一天
export function getFirstDate() {
  let date = new Date();
  date.setDate(1);
  let firstDay = date.toLocaleDateString();
  return getDate(firstDay)
}
//获取当月最后一天
export function getLastDate() {
  let date = new Date();
  date.setMonth(date.getMonth() + 1);
  date.setDate(0);
  let lastDay = date.toLocaleDateString();
  return getDate(lastDay)
}

export function getMonthLast(timestamp) {
  let date = timestamp ? new Date(timestamp) : new Date()
  let year = date.getFullYear()
  let month = date.getMonth()
  // day为0表示获取上一个月最后一天，所以month+1
  // 86300表示一天秒数，最后日期为 23:59:59
  return (new Date(year, month + 1, 0) / 1000 + 86399) * 1000
}

export function getLastMonth() {
  let nowTimes = Date.now();
  let oldTimes = nowTimes - (86400000 * 30);
  let oldDate = getDate(oldTimes); //一个月前的时间
  let nowDate = getDate(nowTimes);//今天的时间
  return [oldDate, nowDate];
}
/**
 * 经纬度转换（高德转百度, gcj02tobd09）
 * @param gglat 纬度
 * @param gglon 经度
 * @example convertAMapToBMap(39.915, 116.404)
 */
export function convertAMapToBMap(gglat, gglon) {
  const [bdlon, bdlat] = coordtransform.gcj02tobd09(gglon, gglat);
  return {
    lng: bdlon,
    lat: bdlat,
  };
}
/**  
 * 执行深拷贝的函数。  
 *  
 * @param {any} value - 需要深拷贝的值。  
 * @param {WeakMap} [hash=new WeakMap()] - 用于存储已拷贝对象的映射，防止循环引用。  
 * @returns {any} 返回深拷贝后的值。  
 */  
export function deepCopy(value, hash = new WeakMap()) {  
  // 如果值不是对象，或者是null（typeof null 也是 'object'），则直接返回该值，因为这些类型不需要深拷贝。  
  if (value == null || typeof value !== 'object') return value;  

  // 处理 Date 对象，通过创建一个新的 Date 对象，并设置相同的时间戳。  
  if (value instanceof Date) {  
      return new Date(value.getTime());  
  }  
    
  // 处理 RegExp 对象，通过创建一个具有相同模式和标志的新 RegExp 对象。  
  if (value instanceof RegExp) {  
      // 使用 value.source 和 value.flags 来复制正则表达式  
      return new RegExp(value.source, value.flags);  
  }  

  // 如果有 Buffer 类型，并且当前值是 Buffer 实例，则进行拷贝。  
  if (typeof Buffer !== 'undefined' && value instanceof Buffer) {  
      let copiedBuffer = Buffer.alloc(value.length);  
      value.copy(copiedBuffer);  
      return copiedBuffer;  
  }  

  // 处理 Map 对象，通过创建一个新的 Map，并复制所有键值对。  
  if (value instanceof Map) {  
      let copiedMap = new Map();  
      for (let [key, val] of value.entries()) {  
          copiedMap.set(deepCopy(key, hash), deepCopy(val, hash));  
      }  
      return copiedMap;  
  }  

  // 处理 Set 对象，通过创建一个新的 Set，并复制所有元素。  
  if (value instanceof Set) {  
      let copiedSet = new Set();  
      for (let val of value) {  
          copiedSet.add(deepCopy(val, hash));  
      }  
      return copiedSet;  
  }  

  // 检查 hash 表中是否已经存在该对象的拷贝，如果存在则直接返回。  
  if (hash.has(value)) {  
      return hash.get(value);  
  }  

  // 创建一个新的数组或对象，根据原始值的类型。  
  let newObj = Array.isArray(value) ? [] : {};  
  // 在 hash 表中记录原始对象和它的拷贝之间的映射。  
  hash.set(value, newObj);  

  // 遍历原始对象的所有自有属性，并递归地进行深拷贝。  
  for (let key in value) {  
      if (value.hasOwnProperty(key)) {  
          newObj[key] = deepCopy(value[key], hash);  
      }  
  }  
  // 返回新创建的对象或数组。  
  return newObj;  
}

/**
 * 获取当前日期以及指定天数前的日期
 * @param {number} days - 传入的天数，用于计算指定天数前的日期
 * @throws {Error} 如果输入的参数不是非负数字，抛出错误
 */

export function getCurrentAndDaysBefore(days) {
  if (typeof days !== 'number' || isNaN(days) || days < 0) {
    throw new Error('Input must be a non-negative number');
  }

  const now = new Date(); // 获取当前时间
  let daysBefore = new Date(now.getTime() - days * 24 * 60 * 60 * 1000); // 计算指定天数前的时间
  let currentTime = now.toISOString().slice(0, 10);
  daysBefore = daysBefore.toISOString().slice(0, 10);
  return [daysBefore,currentTime];
}

export function numberToChineseSimple(num) {
  if (!Number.isInteger(num) || num > 9999999999999999) {
    return '';
  }
  
  if (num === 0) {
    return '零';
  }
  
  const chineseNumbers = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  const chineseUnits = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '兆'];
  
  let isNegative = false;
  if (num < 0) {
    isNegative = true;
    num = -num;
  }
  
  let result = '';
  let digitPos = 0;
  
  while (num > 0) {
    const digit = num % 10;
    const unit = digit !== 0 ? chineseUnits[digitPos] : '';
    
    if (digit === 0) {
      if (result.charAt(0) !== '零') {
        result = chineseNumbers[digit] + result;
      }
    } else {
      result = chineseNumbers[digit] + unit + result;
    }
    
    num = Math.floor(num / 10);
    digitPos++;
  }
  
  // 处理特殊情况
  result = result.replace(/零+/g, '零');
  result = result.replace(/零+$/, '');
  result = result.replace(/^一十/, '十');
  
  return (isNegative ? '负' : '') + result;
}
export function debounce(func, wait, immediate) {

  var timeout;

  return function () {
    var context = this;
    var args = arguments;

    if (timeout) clearTimeout(timeout);
    if (immediate) {
      // 如果已经执行过,不再执行
      var callNow = !timeout;
      timeout = setTimeout(function () {
        timeout = null;
      }, wait)
      if (callNow) func.apply(context, args)
    }
    else {
      timeout = setTimeout(function () {
        func.apply(context, args)
      }, wait);
    }
  }
}